import { FC } from "react";
import { T } from "react-translator-component";
import { Button, Stack } from "@mui/material";

interface LoadMoreButtonProps {
  show: boolean;
  onClick: () => void;
}

const LoadMoreButton: FC<LoadMoreButtonProps> = ({ show, onClick }) => {
  return (
    <>
      {show && (
        <Stack
          sx={styles.loadMoreBtnBox}
          spacing={2}
        >
          <Button onClick={onClick} size="small">
            {T("load_more")}
          </Button>
        </Stack>
      )}
    </>
  );
};

export default LoadMoreButton;

const styles = {
  loadMoreBtnBox: {
    width: "100%",
    color: "grey.500",
    justifyContent: "center"
  }
}